import React, { useState } from "react";
import { toast } from 'react-toastify';
import JsCodeEditor from "../../../components/JsCodeEditor";

const SettingTab = ({updateTestimonialTabData,testimonialTabData}) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [showOpenLinkinNewTab, setOpenLinkinNewTab] = useState(Number(testimonialTabData.settings_is_open_links_in_new_tab));
    const [jsTabCustomJs, setJsTabCustomJs] = useState(testimonialTabData.settings_custom_js);

    // Handlers Open Link in New Tab Change
    const handleOpenLinkinNewTabChange = (e) => {
        const checked = e.target.checked;
        setOpenLinkinNewTab(checked);
        updateTestimonialTabData("settings_is_open_links_in_new_tab", checked); 
    };

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateTestimonialTabData("settings_custom_js", code);
    };

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => {
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    return (
        <div className="testimonials-side-baar-setting-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Setting</span>
                   {/* <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Language</span>
                            <em>English</em>
                        </div>
                        <div className="box-header-row last-border-none">
                            <button className="edit-texts" onClick={() => setActiveSettingElementsTab("edit_texts")}>Edit Texts</button>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("schema_org")}>Schema.org <em>On</em> <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("sorting")}>Sorting <em>Custom</em> <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>*/}
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Open Links in New Tab</span>
                            <div className="form-group">
                                <input id="open_link_tab_toggle" className="chkbx-toggle" type="checkbox" checked={showOpenLinkinNewTab} onChange={handleOpenLinkinNewTabChange} />
                                <label for="open_link_tab_toggle"></label>
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "edit_texts" && (
                <>
                    <div className="inner-box-layout">
                        <span>Language & Texts</span>
                        <button className="button-color button-done" type="button" onClick={() => setActiveSettingElementsTab("main")}>
                            Done
                        </button>
                        <div className="side-baar-box-header">
                            <div className="box-header-row widget-title-color">
                                <span>Language</span>
                                <em>English</em>
                            </div>
                        </div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row bubble-text">
                                <input placeholder="Overall Rating" type="text" name="Overall Rating" />
                            </div>
                            <div className="box-header-row bubble-text">
                                <input placeholder="Load More" type="text" name="Load More" />
                            </div>
                            <div className="box-header-row bubble-text">
                                <input placeholder="Read more" type="text" name="Read more" />
                            </div>
                            <div className="box-header-row bubble-text">
                                <input placeholder="Hide" type="text" name="Hide" />
                            </div>
                            <div className="box-header-row bubble-text">
                                <input placeholder="Verified Customer" type="text" name="Verified Customer" />
                            </div>
                            <div className="box-header-row bubble-text">
                                <input placeholder="Read our {{number}} testimonials" type="text" name="Verified Customer" />
                            </div>
                            <div className="box-header-row bubble-text">
                                <input placeholder="Based on {{number}} testimonials" type="text" name="Verified Customer" />
                            </div>
                            <div className="box-header-row bubble-text">
                                <input placeholder="View on" type="text" name="Verified Customer" />
                            </div>
                        </div>

                    </div>
                </>
            )}

            {activeSettingElementsTab === "schema_org" && (
                <>
                    <div className="inner-box-layout">
                        <button className="button-color" type="button" onClick={() => setActiveSettingElementsTab("main")}> Back</button> <span className="schema">Schema.org</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Open Links in New Tab</span>
                                <div className="form-group">
                                    <input id="open_link_tab_toggle" className="chkbx-toggle" type="checkbox" value="1" />
                                    <label for="open_link_tab_toggle"></label>
                                </div>
                            </div>
                        </div>
                        <p>Reviews Schema.org markup will let search engines read the reviews and overall rating on your website and display them in search results. It will increase the attractiveness of your website snippet and, consequently, it will lead to a higher number of redirects from search engines. <a href="/"> Learn More</a></p>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "sorting" && (
                <>
                    <div className="inner-box-layout">
                        <button className="button-color" type="button" onClick={() => setActiveSettingElementsTab("main")}>Back</button> <span className="schema">Sorting</span>
                        <p>Testimonials Sorting</p>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <ul className="pages-list">
                                    <li>
                                        <div className="form-group">
                                            <input id="test1" wfd-id="id1" type="radio" name="radio-group" />
                                            <label for="test1">Custom</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="test2" wfd-id="id2" type="radio" name="radio-group" />
                                            <label for="test2">Most recent first</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="test3" wfd-id="id3" type="radio" name="radio-group" />
                                            <label for="test3">Random</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <button className="validate" onClick={handleValidateClick}>Validate</button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default SettingTab;